export function encodeQueryData(data: Record<string, unknown>): string {
    const ret = [];
    for (const d in data) ret.push(`${encodeURIComponent(d)}=${encodeURIComponent(data[d] as string)}`);
    return ret.join('&');
}